import Immutable from 'seamless-immutable'

export default Immutable({
  selected: {
    id: null,
    type: 'geometries',
  },
  tool: 'translate',
  interact: null,
})



// WEBPACK FOOTER //
// ./src/store/editor/editor.model.js